import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  //todo: version should be a variable
  title = 'GoVideo v2';
  constructor() {
  }
  ngOnInit(): void {}
}
